<template>
	<div class="g-style-block-preview">
		<component
			:is="blockComponent"
			v-if="blockComponent"
			:data="previewData"
			:editable="false"
			v-bind="previewProps"
		/>
	</div>
</template>

<script>
	import { getBlockComponent } from '../blocks/index.js';
	import { getStylePreviewData } from '../templates.js';
	import { PAY_FILE_LIST_TYPE } from '../utils/payFileList.js';
	import { PAY_FILE_COLLECTION_TYPE } from '../utils/payFileCollection.js';
	import { PAY_FILE_UNLOCK_TYPE } from '../utils/payFileUnlock.js';
	import { PAY_AUDIO_LIBRARY_TYPE } from '../utils/payAudioLibrary.js';
	import { PAY_VIDEO_LIST_TYPE } from '../utils/payVideoList.js';
	import { VIDEO_LIST_TYPE } from '../utils/videoList.js';
	import { AUDIO_LIBRARY_TYPE } from '../utils/audioLibrary.js';

	const COMPACT_PREVIEW_TYPES = new Set([
		PAY_FILE_LIST_TYPE,
		PAY_FILE_COLLECTION_TYPE,
		PAY_FILE_UNLOCK_TYPE,
		PAY_AUDIO_LIBRARY_TYPE,
		PAY_VIDEO_LIST_TYPE,
	]);

	const SHOW_PLAY_ICON_TYPES = new Set([
		VIDEO_LIST_TYPE,
		AUDIO_LIBRARY_TYPE,
		PAY_AUDIO_LIBRARY_TYPE,
		PAY_VIDEO_LIST_TYPE,
	]);

	/** 样式库预览：直接渲染区块组件，避免手写 HTML */
	export default {
		name: 'GStyleBlockPreview',
		props: {
			type: {
				type: String,
				required: true,
			},
		},
		computed: {
			blockComponent() {
				return getBlockComponent(this.type);
			},
			previewData() {
				return getStylePreviewData(this.type);
			},
			previewExtraProps() {
				if (COMPACT_PREVIEW_TYPES.has(this.type)) {
					return { compact: true };
				}
				return {};
			},
			extraPreviewProps() {
				return SHOW_PLAY_ICON_TYPES.has(this.type)
					? { showPlayIcon: true }
					: {};
			},
			previewProps() {
				return { ...this.previewExtraProps, ...this.extraPreviewProps };
			},
		},
	};
</script>

<style scoped lang="less">
	.g-style-block-preview {
		width: 100%;
		pointer-events: none;
		user-select: none;

		:deep(.g-block-title-padding),
		:deep(.g-block-body-padding),
		:deep(.g-block-divider-padding) {
			margin-bottom: 0;
		}

		:deep(.g-block-pay-unlock__card) {
			border-top: none;
		}
	}
</style>
